/**
 * @ngdoc Controller
 * @name InstallationOverviewController
 */
import { handleFileDownload } from "@/utils/download";
import { HEADER_TYPE_ENHANCED } from '@/constants/header';
import {
    initializeDropdownFilter,
    getDropdownFilterBattery,
    getDropdownFilterGenerator,
    getDropdownFilterGrid,
    getDropdownFilterLoad,
    getDropdownFilterSolar,
    getDropdownFilterTank,
    getDropdownFilterTemperature,
    getDropdownFilterLastUpdate,
    transformDropdownValuesToFilters,
    getAlarmsToDropdownFilter,
    getTeamsToDropdownFilter,
    getTagsToDropdownFilter,
    getGroupsToDropdownFilter,
} from "../../../utils/filterBar/installationsOverviewFilterValues.js";

(function() {
    'use strict';

    angular.module('vrm.core')
        .controller('InstallationOverviewController', InstallationOverviewController);
    /**
     * @constructor
     * @ngInject
     */
    function InstallationOverviewController(
        $timeout,
        $rootScope,
        $scope,
        $state,
        $stateParams,
        $injector,
        InstallationsService,
        $filter,
        $location,
        ApiService,
        vrmNotificationsService,
        vrmNotificationType,
        locale,
        VrmModalService,
        localStorageService,
        UserService,
        vrmConfig,
    ) {
        // Set the header type enahnced value
        $scope.HEADER_TYPE_ENHANCED = HEADER_TYPE_ENHANCED;

        setupAlarmPanelOptimizations($scope, $injector);
        // Toggle mobile view layout for screen under 750px
        $scope.mobileView = window.innerWidth < 750;
        angular.element(window).on('resize', _.debounce(function() {
            $scope.mobileView = window.innerWidth < 750;
            $scope.$digest();
        }, 250));

        $scope.$on('$destroy', function() {
            angular.element(window).off('resize');
            angular.element(window).off('scroll');
        });
        //Save scroll position on the page
        angular.element(window).on('scroll', function (){
            sessionStorage.setItem('scrollPosition', pageYOffset);
        });

        $scope.dropdownFilter = [];

        checkForRecentLoginRedirect();

        /**
         * Check if the user just signed in and was redirected to the installation overview.
         *
         * If so, we check the installation count to see if the user should be redirected to fleet-monitor.
         * After the initial login, the users site count will be stored in local storage and, if set, that will be used
         * to redirect the user immediately when signing in.
         */
        async function checkForRecentLoginRedirect() {
            if ($stateParams && $stateParams.justSignedIn && !$stateParams.overrideFleetMonitorRedirect) {
                // Wait for installations list to be loaded.
                await InstallationsService.loading;

                const count = InstallationsService.installations.length || 0;
                const threshold = vrmConfig.fleetOwnerThreshold || 10;

                if (count >= threshold) {
                    $state.go('base.fleet-monitor', {}, {location: 'replace'});
                }
            }
        }

        const initializeDropdownFilterWithTags = async () => {
            await InstallationsService.loading;
            $scope.dropdownFilter = initializeDropdownFilter(InstallationsService.tags, InstallationsService.alarm_tags);
        }

        /*
        * Passed to the filter bar to load when it's open
        */
        $scope.beforeRenderFilterBar = async () => {
            if($scope.dropdownFilter.length === 0) {
                await initializeDropdownFilterWithTags();
                initializeOverviewSearchFromUrlParams();
            }
        }

        if($location.search()){
            $scope.beforeRenderFilterBar();
        }

        $scope.applyFilter = () => {
            const newFilter = transformDropdownValuesToFilters($scope.dropdownFilter);
            addDropdownFilterToUrlParams();
            $scope.overviewSearch = {
                ... $scope.overviewSearch,
                ...newFilter,
            };
        }

        $scope.clearFilterBarValues = async (clear) => {
            if(clear === "" || clear === null || clear === undefined){
                $scope.dropdownFilter = initializeDropdownFilter(InstallationsService.tags, InstallationsService.alarm_tags);
                addDropdownFilterToUrlParams();
                $scope.applyFilter(); // apply filter
                return;
            }
            $scope.dropdownFilter = $scope.dropdownFilter.map(filter => {
                if(filter.id === clear){
                    switch (clear) { // new values
                        case 'battery':
                            return getDropdownFilterBattery();
                        case 'solar':
                            return getDropdownFilterSolar();
                        case 'load':
                            return getDropdownFilterLoad();
                        case 'grid':
                            return getDropdownFilterGrid();
                        case 'generator':
                            return getDropdownFilterGenerator();
                        case 'tank':
                            return getDropdownFilterTank();
                        case 'temperature':
                            return getDropdownFilterTemperature();
                        case 'last_timestamp':
                            return getDropdownFilterLastUpdate();
                        case 'alarm':
                            return getAlarmsToDropdownFilter(InstallationsService.alarm_tags);
                        case 'teams':
                            return getTeamsToDropdownFilter(InstallationsService.tags);
                        case 'tags':
                            return getTagsToDropdownFilter(InstallationsService.tags);
                        case 'groups':
                            return getGroupsToDropdownFilter(InstallationsService.tags);
                    }
                } else {
                    return filter;
                }
            })
            $scope.applyFilter(); // apply filter
        }

        $scope.doneFilter = () => {
            $scope.applyFilter(); // apply filter
            $scope.panels.filterBar = false; // and close tags panel
        }

        $scope.onRunningSinceLoaded = (runningSinceInstallations) => {
            let installations = {}
            Object.keys(runningSinceInstallations)
                .forEach(installation => {
                    if(runningSinceInstallations[installation].live ){
                        installations = {
                            ...installations,
                            [installation]: runningSinceInstallations[installation]
                        }
                    }
                })

            $scope.overviewSearch.runningSince = installations;

            $scope.overviewSearch.generator
                && $scope.overviewSearch.generator.running
                && ($scope.overviewSearch.generator.running.min != ""
                    || $scope.overviewSearch.generator.running.max != "")
                && $scope.applyFilter(); // Only apply filter if there are running since filters
        }

        // Local model for over search term, tags
        $scope.overviewSearch = {
            term: $stateParams.search || "",
            tags: [],
            location: null,
            ...transformDropdownValuesToFilters($scope.dropdownFilter),
            // ok, warning, error
            status: [],
            searchResults: [],
        };

        $scope.updateSearchOverview = (listInstallations) => {
            $scope.overviewSearch.searchResults = listInstallations;
        }

        $scope.installationCount = 0;

        $scope.$watchGroup([
            'myInstallations', 'customerInstallations',
            '$root.userState.isDemo',
        ], () => {
            const first = {
                title: 'installationoverview.myInstallations',
                icon: 'sg-vrm-icon_005_pointer-my-32px',
                installations: $scope.myInstallations,
                showAdd: !($scope.$root.userState.isDemo),
            };
            const sections = [
                first,
                {
                    title: 'installationoverview.installationsOfCustomers',
                    icon: 'sg-vrm-icon_006_pointer-customers-32px',
                    installations: $scope.customerInstallations,
                    showAdd: false,
                },
            ].filter(item => item.installations.length > 0);
            if (sections.length === 0) {
                sections.push(first);
            }
            $scope.sections = sections;
            $scope.installationCount = ($scope.myInstallations.length || 0) + ($scope.customerInstallations.length || 0);
        });


        const addDropdownFilterToUrlParams = () => {
            $scope.dropdownFilter.forEach(filters => {
                filters.options.forEach(filter => {
                    const searchParam = `${filters.id}-${filter.variable}`;
                    let searchParamValue = null;
                    if(filter.type === "check" || filter.type === "tags") {
                        const listOfChecks = filter.options
                            .filter(check => check.value)
                            .map(check => check.id);
                         searchParamValue = listOfChecks.length > 0 ? listOfChecks.join(",") : null;
                    }
                    else if(filter.type === "radio" && filter.selected !== "") {
                        searchParamValue = filter.selected;
                    }
                    else if(filter.type === "minMax" && (filter.min !== "" || filter.max !== "" )) {
                        searchParamValue = `${filter.min},${filter.max}`;
                    }
                    $location.search(searchParam, searchParamValue);
                })
            })
        }

        const initializeOverviewSearchFromUrlParams = () => {
            const searchParams = $location.search();
            $scope.dropdownFilter.forEach(filters => {
                filters.options.forEach(filter => {
                    const searchParam = `${filters.id}-${filter.variable}`;
                    if(searchParams[searchParam]){
                        if(filter.type === "check" || filter.type === "tags") {
                            const urlChecks = searchParams[searchParam]
                                .toLowerCase()
                                .split(",")
                                .filter(param => param != '');
                            filter.options.forEach(check => {
                                if(urlChecks.includes(check.id.toString().toLowerCase())){
                                    check.value = true;
                                }
                            })
                        }
                        else if(filter.type === "radio") {
                            filter.selected = searchParams[searchParam];
                        }
                        else if(filter.type === "minMax") {
                            const [min, max] = searchParams[searchParam].split(",");
                            filter.min = min || "";
                            filter.max = max || "";
                        }
                    }
                })
            })
            // update filter
            const newFilter = transformDropdownValuesToFilters($scope.dropdownFilter);
            $scope.overviewSearch = {
                ... $scope.overviewSearch,
                ...newFilter,
            }
        }

        $scope.getAddButtonOffset = function() {
            var element = angular.element(document.getElementById('add-button'));
            if (element.length > 0) {
                return element[0].offsetWidth + 'px';
            }
        };

        $scope.getTaskStyles = function() {
            const offset = $scope.getAddButtonOffset();
            if (window.innerWidth > 1280 && offset) {
                return  {
                    'right':$scope.sections[0].showAdd ? 'calc(2.5rem + ' + offset + ')' : '0',
                }
            } else {
                return {}
            }
        }

        $scope.map = {
            bounds: null,
            control: {},
            center: {
                latitude: 0,
                longitude: 0
            },
            filter: 'all',
            zoom: 7,
            layers: {
                runtimeUntilService: true,
                tank: true,
                showOk: true,
                showWarnings: true,
                showAlarms: true,
            },
        };

        $scope.animating = false;
        $scope.panels = {
            alarms: $stateParams.alarms,
            search: $stateParams.search || false,
            map: false,
            filterBar: false,
            columns: false,
        };

        $scope.$watch('panels.alarms', alarms => {
            $state.go('.', {
                alarms: alarms || null,
                isMapOpen: null,
            }, {
                location: 'replace',
            });
        });

        // The default layout is determined by the entries with `enabled` set to true initially
        $scope.columns = {
            name: {header: 'installationoverview.installationName', enabled: true},
            stateOfCharge: {header: 'installationoverview.stateOfCharge', enabled: true},
            solarYield: {header: 'installationoverview.solarYield', enabled: true},
            consumption: {header: 'installationoverview.consumption', enabled: true},
            grid: {header: 'installationoverview.grid', enabled: true},
            paygo: {header: 'installationoverview.paygo', enabled: false},
            generator: {header: 'installationoverview.generator', enabled: true},
            serviceTime: {header: 'installationoverview.serviceTime', enabled: false},
            runningSince: {header: 'installationoverview.runningSince', enabled: false},
            tanks: {header:'installationoverview.tanks', enabled: true},
            temperature: {header: 'installationoverview.temperature', enabled: true},
            lastUpdate: {header: 'installationoverview.last_update', enabled: true},
            dateAdded: {header: 'installationoverview.dateAdded', enabled: false},
            alarm: {header: 'installationoverview.alarm', enabled: true},
        };

        function hidePaygoColumn(){
            loadInstallations().then((data)=>{
                if(!_.find(data,{isPaygo:1})){
                    $scope.columns.paygo.hide=true;
                    $scope.columns.paygo.enabled=false;
                }
            });
        }

        function loadInstallations() {
            return InstallationsService.loading.then(() => InstallationsService.installations);
        }

        const COLUMNS_STORAGEKEY = 'installation-overview.columns';
        const storedColumns = localStorageService.get(COLUMNS_STORAGEKEY);
        const defaultColumns = Object.keys($scope.columns).filter(key => $scope.columns[key].enabled);
        const enabledColumns = ((storedColumns && Array.isArray(storedColumns)) ? storedColumns : defaultColumns).slice();
        Object.keys($scope.columns).forEach(function (columnName) {
            var column = $scope.columns[columnName];
            column.enabled = _.includes(enabledColumns, columnName);
        });

        function doArraysDiffer(a, b) {
            // The arrays differ if either has an item not present in the other
            return a.some(item => !b.includes(item)) || b.some(item => !a.includes(item));
        }

        $scope.$watch('columns', function () {
            hidePaygoColumn();
            const columns = _.chain($scope.columns)
                .map(function (column, name) {
                    return {name: name, enabled: column.enabled};
                })
                .filter(function (info) {
                    return info.enabled;
                })
                .map(function (info) {
                    return info.name;
                })
                .value();
            $scope.enabledColumns = columns;
            // Check for differences with the default
            if (doArraysDiffer(columns, defaultColumns)) {
                localStorageService.set(COLUMNS_STORAGEKEY, columns);
            } else {
                // Configuration is same as default
                // Removing the key ensures that the column list updates when the default changes
                localStorageService.remove(COLUMNS_STORAGEKEY);
            }
        }, true);

        // When the columns change this requires highcharts to be reflown
        $scope.$watch('columns', () => $scope.$broadcast('highchartsng.reflow'), true);

        $scope.enabledColumns = [];


        var animateTimer = null;
        var scheduleAnimation = function() {
            $timeout.cancel(animateTimer);
            $scope.animating = true;
            animateTimer = $timeout(function() {
                $scope.animating = false;
                $scope.$evalAsync();
            }, 700, false);
        };

        //Disable other panels on change
        $scope.$watchCollection('panels', function(newPanels, oldPanels) {
            for (var i in newPanels) {
                if (!oldPanels[i] && newPanels[i]) {
                    for (var n in $scope.panels) {
                        if (i != n && $scope.panels[n]) {
                            scheduleAnimation();
                            $scope.panels[n] = false;
                        }
                    }
                }
            }
        });

        var downloadPending = false;
        $scope.downloadReport = function() {
            if (downloadPending) {
                locale.ready('installationoverview').then(function () {
                    vrmNotificationsService.add( {type: vrmNotificationType.ERROR, message: locale.getString('installationoverview.download_pending') });
                });
                return;
            }

            VrmModalService.openDownloadModal($scope, 'installationoverview.preparing_download');
            downloadPending = true;

            ApiService.download(vrmConfig.reportUrl, null, true, 'POST')
                .then(function(response) {
                    handleFileDownload(response.data, "production_report_30days.xlsx");
                    downloadPending = false;
                    $.magnificPopup.close();
                }, function() {
                    locale.ready('installationoverview').then(function () {
                        vrmNotificationsService.add( {type: vrmNotificationType.ERROR, message: locale.getString('installationoverview.download_timeout') , timeout: 30000});
                    });
                    downloadPending = false;
                    $.magnificPopup.close();
                });
        };

        $scope.openModal = function() {
            const filteredSiteIds = $scope.getFilteredSiteIds();
            const allSiteIds = $scope.installations.map(installation => installation.idSite);
            VrmModalService.openDownloadProductionReportModal($scope, allSiteIds, filteredSiteIds);
        };

        $scope.downloadVisibleOverviewData = function () {
            downloadOverviewData(true);
        };

        $scope.downloadFullOverviewData = function () {
            downloadOverviewData(false);
        };

        function downloadOverviewData(allColumns) {
            const filteredSiteIds = $scope.getFilteredSiteIds();

            let data = {
                'columns': $scope.columns,
                'siteIds': filteredSiteIds,
                'onlyVisible': allColumns,
                'jsonResponse': false // Not used from the frontend
            }
            ApiService.download('/installation-overview-download', data, false, 'POST').then(response => {
                handleFileDownload(response.data, "installation-overview.xlsx");
            })
        }

        //Set map state from params
        $scope.isMapStateParamLoaded = false
        $scope.isMapLocationInitialized = false

        $scope.mapbox = null;

        $scope.onMapboxLoaded = function (map) {
            $scope.mapbox = map;
        };

        $scope.$watch('panels.map', function(panel) {
            if ($scope.mapbox) {
                setTimeout(() => {
                    $scope.mapbox.resize();
                }, 2000); // 2 seconds
            }
        });

        $scope.$on('$locationChangeSuccess', function(event, newUrl, oldUrl) {
            initializeOverviewSearchFromUrlParams()
            $scope.overviewSearch.term = $location.search().search || "";
        });

        /*
         * Return the site ids of the installations filtered by the user
         */
        $scope.getFilteredSiteIds = function () {
            let filteredInstallations = $filter('installationOverviewFilter')($scope.installations, $scope.overviewSearch, undefined);
            return filteredInstallations.map(installation => installation.idSite);
        }

        /**
         * Check if a given coordinate point is within the specified bounds.
         *
         * @param point
         * @param mapBounds
         * @returns {boolean}
         */
        function isPointWithinMapBounds(point, mapBounds) {
            const lat = point[0];
            const lng = point[1];
            const lat1 = mapBounds[0];
            const lng1 = mapBounds[1];
            const lat2 = mapBounds[2];
            const lng2 = mapBounds[3];
            if (lng1 >= lng2) {
                // Map region does not span the 180 degree meridian
                if (lat2 <= lat && lat <= lat1 && lng2 <= lng && lng <= lng1) {
                    return true;
                }
            } else {
                // Map region spans the 180 degree meridian
                if (lat2 <= lat && lat <= lat1 && (lng2 <= lng && lng <= 180 || -180 <= lng && lng <= lng1)) {
                    return true;
                }
            }

            return false;
        }

        /**
         * Get the initial center coordinates from the URL params.
         *
         * @returns {{lng: number, lat: number}}
         */
        function getMapCoordinatesFromParams() {
            if (!$location.search().location) {
                return {
                    lng: 0,
                    lat: 0
                }
            }
            const params = $location.search().location.split(',')
            return {
                lat: parseFloat(params[0]),
                lng: parseFloat(params[1]),
            }
        }

        /**
         * Get the initial zoom level from the URL params.
         *
         * @returns {number}
         */
        function getMapZoomLevelFromParams() {
            if (!$location.search().location) {
                return 7;
            }

            const params = $location.search().location.split(',')

            // Make sure a zoom value actually exists.
            if (params.length < 3) {
                return 7;
            }

            return parseInt(params[2]);
        }

        /**
         * Set the initial mapOpen state from URL params.
         */
        function setMapStateFromParams() {
            const values = $location.search();

            $scope.panels.map = values.isMapOpen == '1';

            let runtimeUntilService = $scope.map.layers.runtimeUntilService;
            let tank = $scope.map.layers.tank;

            let showOk = $scope.map.layers.showOk;
            let showWarnings = $scope.map.layers.showWarnings;
            let showAlarms = $scope.map.layers.showAlarms;

            if (values.service) {
                runtimeUntilService = values.service == '1';
            }

            if (values.tank) {
                tank = values.tank == '1';
            }

            const markers = values.markers;
            if (markers) {
                const parts = markers.split(',');

                showOk = parts.includes('ok');
                showWarnings = parts.includes('warning');
                showAlarms = parts.includes('alarm');

                // Set the initial filter state.
                updateStatusSearch(markers);
            } else {
                // Set the initial filter state.
                updateStatusSearch(['ok', 'warning', 'alarm']);
            }

            $scope.map.layers = {
                runtimeUntilService: runtimeUntilService,
                tank: tank,
                showOk: showOk,
                showWarnings: showWarnings,
                showAlarms: showAlarms,
            };

            $scope.isMapStateParamLoaded = true;
        }

        /**
         * Update the overviewSearch params for status.
         *
         * Finds all installations that match the enabled statuses and adds their id's to the filter field.
         *
         * @param status
         */
        function updateStatusSearch(status) {
            $scope.overviewSearch.status = status;
        }

        /**
         * Update the mapOpen URL param to reflect the current state.
         *
         * @param isOpen
         */
        function updateParamsMapLoaded(isOpen) {
            if ($scope.isMapStateParamLoaded) {
                $location.search('isMapOpen', +isOpen);

                if (isOpen) {
                    $location.search('alarms', null);

                    if ($scope.map.bounds) {
                        // Update initial table filtering when map is opened.
                        $scope.onMapBoundsChanged($scope.map.bounds);
                    }
                } else {
                    $scope.overviewSearch.location = null;
                }
            }
        }


        /**
         * Update URL params whenever the map location moves.
         *
         * @param location
         */
        $scope.onMapLocationChanged = (location) => {
            if ($scope.mapbox && $scope.isMapStateParamLoaded && $scope.isMapLocationInitialized) {
                $location.search('location',`${location.lat},${location.lng},${location.zoom}`);
            }
        }

        /**
         * Search and filter the table installations whenever map bounds change.
         *
         * @param bounds
         */
        $scope.onMapBoundsChanged = (bounds) => {
            $scope.map.bounds = bounds;

            if (!$scope.panels.map) return

            $scope.overviewSearch.location = [];

            let lat1 = bounds.getNorthEast().lat;
            let lng1 = bounds.getNorthEast().lng;

            let lat2 = bounds.getSouthWest().lat;
            let lng2 = bounds.getSouthWest().lng;

            $scope.installations.forEach((e,i) => {
                let coords = [0, 0];

                if (e.data.lt && e.data.lg) {
                    coords = [e.data.lt.rawValue, e.data.lg.rawValue];
                }

                if (!isPointWithinMapBounds(coords, [lat1,lng1,lat2,lng2])) return

                $scope.overviewSearch.location.push(e.id)
            });
        }

        /**
         * Update URL params whenever layers change.
         *
         * @param layers
         */
        $scope.onMapLayersChanged = (layers) => {
            if ($scope.mapbox && $scope.isMapStateParamLoaded) {
                $scope.map.layers = layers;

                $location.search('service', +layers.runtimeUntilService);
                $location.search('tank', +layers.tank);

                let status = [];
                if (layers.showOk) {
                    status.push('ok');
                }

                if (layers.showWarnings) {
                    status.push('warning');
                }

                if (layers.showAlarms) {
                    status.push('alarm');
                }

                updateStatusSearch(status);

                $location.search('markers', status.join(','));
            }
        }

        $scope.onInstallationPopupClicked = (installation) => {
            $state.go('base.installation.dashboard', {id: installation.idSite});
        }

        /**
         * Set the initial map location.
         *
         * If a URL param exists, use it to set the location.
         * If not, calculate the location so all installations are visible.
         *
         * @param forceReset
         */
        function updateMapLocation(forceReset = false) {
            if ($scope.mapbox) {
                if(!$location.search().location || forceReset) {
                    const installations = forceReset ? $scope.installations : $scope.mapInstallations;
                    // If only a single installation exists, center the map on that location.
                    if (installations.length === 1) {
                        const installation = installations[0];

                        const lat = parseFloat(installation.data.lt.rawValue) || undefined;
                        const lng = parseFloat(installation.data.lg.rawValue) || undefined;

                        $scope.mapbox.jumpTo({
                            center: [lng, lat],
                            zoom: 5,
                        });

                        $scope.isMapLocationInitialized = true;
                        return;
                    }

                    let smallestLat, smallestLng, largestLat, largestLng;
                    installations.forEach((installation) => {
                        let lat = 0;
                        if (installation.data.lt) {
                            lat = parseFloat(installation.data.lt.rawValue) || 0;

                            if (smallestLat === undefined || lat <= smallestLat) {
                                smallestLat = lat;
                            }

                            if (largestLat === undefined || lat >= largestLat) {
                                largestLat = lat;
                            }
                        }

                        let lng = 0;
                        if (installation.data.lg) {
                            lng = parseFloat(installation.data.lg.rawValue) || 0;

                            if (smallestLng === undefined || lng <= smallestLng) {
                                smallestLng = lng;
                            }

                            if (largestLng === undefined || lng >= largestLng) {
                                largestLng = lng;
                            }
                        }
                    });

                    if (smallestLat !== undefined && largestLat !== undefined && smallestLng !== undefined && largestLng !== undefined) {
                        $scope.mapbox.fitBounds([
                            [smallestLng - 5, largestLat + 5],
                            [largestLng + 5, smallestLat - 5],
                        ]);
                    }
                } else {
                    const location = getMapCoordinatesFromParams();
                    const zoom = getMapZoomLevelFromParams();

                    $scope.mapbox.jumpTo({
                        center: [location.lng, location.lat],
                        zoom: zoom,
                    });
                }

                $scope.isMapLocationInitialized = true;
            }
        }

        $scope.visibleInstallationCount = () => {
            return $scope.getFilteredSiteIds().length;
        }

        $scope.totalInstallationCount = () => {
            return $scope.myInstallations.length;
        }

        $scope.hasFiltersApplied = () => {
            return $scope.visibleInstallationCount() < $scope.totalInstallationCount();
        };

        /**
         * Clear all filters applied to the installation overview list.
         *
         * Removes all filterBar, map layers and location filters.
         */
        $scope.onClearFilters = (e) => {
            //Broadcast clear event to enhanced search
            $rootScope.$broadcast('clearEvent');
            // Reset filter related url params
            $location.search('markers', null);
            $location.search('service', null);
            $location.search('tank', null);
            $location.search('search', null);

            // Reset the local search object
            $scope.overviewSearch.term = "";
            $scope.overviewSearch.status = ['ok', 'warning', 'alarm'];
            $scope.overviewSearch.location = null;
            $scope.clearFilterBarValues();

            // Reset the local map layers object
            $scope.map.layers = {
                runtimeUntilService: true,
                tank: true,
                showOk: true,
                showWarnings: true,
                showAlarms: true,
            };

            if ($location.search().location) {
                $location.search('location', null);
                updateMapLocation(true);
            }

            if (e && e.map) {
                // If location is reset while in fullscreen mode, the installation list will be filtered again after
                // exiting fullscreen since the canvas size is different and some installations might not be in view
                // anymore. Add a listener for fullscreen-mode changes and reset the location when we exit fullscreen.
                // This causes the map view to adjust to the smaller canvas.
                const fullscreenCallback = () => {
                    document.removeEventListener('fullscreenchange', fullscreenCallback);

                    // Add a small delay to give the map some time to transition back to the smaller view.
                    setTimeout(() => {
                        updateMapLocation(true);
                    }, 500);
                };

                document.addEventListener("fullscreenchange", fullscreenCallback);
            }
        };

        $scope.$watchGroup(['panels.map', 'mapbox'], function() {
            const visible = $scope.panels.map;

            if (visible && $scope.mapbox) {
                updateMapLocation();
            }
        });

        $scope.$watch('panels.map', function(panel) {
            function updateMapMarkers() {
                if ($scope.map.filter === 'my') {
                    $scope.mapInstallations = $scope.myInstallations;
                } else if ($scope.map.filter === 'customer') {
                    $scope.mapInstallations = $scope.customerInstallations;
                } else {
                    $scope.mapInstallations = $scope.installations;
                }
                // Filter through installations to apply the search (tags or terms, excluding location)
                $scope.mapInstallations = $filter('installationOverviewFilter')($scope.mapInstallations, $scope.overviewSearch, undefined, false);

            }

            // Watch for changes on the installations collection
            $scope.$watchCollection('installations', updateMapMarkers);
            $scope.$watch('map.filter', updateMapMarkers);
            // Watch for changes on the overview search
            $scope.$watch('overviewSearch.term', updateMapMarkers);
            $scope.$watch('overviewSearch.status', updateMapMarkers);
            // Filter Bar
            $scope.$watch('overviewSearch.tags', updateMapMarkers);
            $scope.$watch('overviewSearch.groups', updateMapMarkers);
            $scope.$watch('overviewSearch.alarm', updateMapMarkers);
            $scope.$watch('overviewSearch.teams', updateMapMarkers);
            $scope.$watch('overviewSearch.battery', updateMapMarkers);
            $scope.$watch('overviewSearch.solar', updateMapMarkers);
            $scope.$watch('overviewSearch.load', updateMapMarkers);
            $scope.$watch('overviewSearch.grid', updateMapMarkers);
            $scope.$watch('overviewSearch.generator', updateMapMarkers);
            $scope.$watch('overviewSearch.tank', updateMapMarkers);
            $scope.$watch('overviewSearch.temperature', updateMapMarkers);
            $scope.$watch('overviewSearch.last_timestamp', updateMapMarkers);

            if (!$scope.isMapStateParamLoaded) {
                setMapStateFromParams();
            }

            if (!$scope.isMapLocationInitialized) {
                updateMapLocation();
            }

            updateParamsMapLoaded(panel);
        });

        // Dense mode
        // Note: for some reason ngVue does not trigger watches if the ng-model is on a direct scope property
        // Note: stored as detail-mode so the absence defaults detailMode to false
        $scope.detailMode = {
            enabled: !!localStorageService.get('installation-overview.detail-mode')
        }
        $scope.$watch('detailMode.enabled', (value) => {
            localStorageService.set('installation-overview.detail-mode', value);
        });

        $scope.total = {
            enabled: (localStorageService.get('installation-overview.installation-overview.total') === null)? true :
                localStorageService.get('installation-overview.installation-overview.total')
        };
        $scope.$watch('total.enabled', (value) => {
            localStorageService.set('installation-overview.installation-overview.total', value);
        });

        // If user has a lot of installations and not yet set a dense-mode preference, default to dense mode
        $scope.$watch('installations.length', (value) => {
            if (value > 20 && localStorageService.get('installation-overview.detail-mode') === null) {
                $scope.detailMode.enabled = false;
            }
        });
    }
})();


function setupAlarmPanelOptimizations($scope, $injector) {
    $injector.invoke(/* @ngInject*/ (AlarmsCacheService) => {
        /**
         * Performance: hide <vrm-alarms> until the first time the panel is expanded.
         * This avoids a request for the alarms data as well as save some memory for caching the alarms response
         */
        $scope.$watch('panels.alarms', () => {
            $scope.alarmsEverExpanded |= $scope.panels.alarms;
        });
        /**
         * Memory: clear the alarms cache when leaving the page without the alarms panel open
         * because the data is not expected to be there immediately when going back
         */
        $scope.$on('$destroy', () => {
            if (!$scope.panels.alarms) {
                AlarmsCacheService.clear();
            }
        });
    });
}

